import { useTranslation } from "react-i18next";

const MAIN_STORE = "https://kaspreadsheet.com";

export default function CtaFooter() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20coral%20and%20terracotta%20abstract%20fashion%20flat%20lay%20with%20luxury%20handbags%20sneakers%20and%20accessories%20arranged%20artistically%20on%20a%20warm%20peach%20background%20soft%20natural%20light%20editorial%20product%20photography%20minimal%20aesthetic%20warm%20earth%20tones%20no%20text%20high%20quality&width=1600&height=700&seq=cta-footer-bg-01&orientation=landscape"
          alt="AllChinaBuy spreadsheet"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-24">
        <h2 className="font-heading text-3xl font-bold text-white md:text-4xl lg:text-5xl">
          {t("cta.title")}
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/80 md:text-base">
          {t("cta.p1")}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href={MAIN_STORE}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-foreground-950 transition-all hover:bg-white/90 whitespace-nowrap cursor-pointer"
          >
            {t("cta.btn1")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
          <a
            href={MAIN_STORE}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-white/20 whitespace-nowrap cursor-pointer"
          >
            {t("cta.btn2")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}